import { OverlayRef } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import { BRN_OVERLAY_REF } from 'projects/brn-frontend/src/app/core/services/brn-overlay.service';

import { BotSelectors } from 'projects/brn-frontend/src/app/core/store/bot/bot.selectors';
import { SendFile } from '../../store';
import { ScenariosPopupComponent } from '../scenarios-popup/scenarios-popup.component';

@Component({
  selector: 'brn-media-popup',
  templateUrl: './media-popup.component.html',
  styleUrls: ['./media-popup.component.scss'],
})
export class MediaPopupComponent implements OnInit {
  @ViewSelectSnapshot(BotSelectors.scenarios)
  scenarios!: any[];

  public scenariosPopupComponent = ScenariosPopupComponent;

  constructor(
    private store: Store,
    @Inject(BRN_OVERLAY_REF) private overlayRef: OverlayRef
  ) {
    this.overlayRef.backdropClick().subscribe(() => {
      this.close();
    });
  }

  ngOnInit(): void {}

  sendFile(event: Event, type: 'image' | 'file' | 'audio' | 'video'): void {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    const targetFile = files[0];
    if (targetFile) {
      this.store.dispatch(new SendFile(targetFile, type));
      target.value = '';
      this.close();
    }
  }

  private close(): void {
    this.overlayRef.detach();
    this.overlayRef.dispose();
  }
}
